import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import {getTimelineMax} from "../../../helpers/gsap"

class NRTMenu extends Component {

    animation = null

    state = {
        zIndex: -1
    }

    componentWillMount() {


    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.open)
            this.animation.play()
        else
            this.animation.reverse()
    }


    componentDidMount() {


        if (!!window.TimelineMax) {
            const TimelineMax = getTimelineMax()
            const timeline = new TimelineMax()

            this.animation = timeline
                .from(".nrt-menu .menu-overlay", .2, {
                    opacity:0,

                })
                .from(".nrt-menu nav", .5, {
                    y: '+=300',
                    ease: 'Power2.easeOut',
                    force3D: true,

                })
                .staggerFrom(".nrt-menu ul li", .6, {
                    opacity: 0,
                    delay: 0,
                    force3D: true,
                    y: 25,
                    ease: 'Power2.easeInOut',
                }, .3)
                .pause()
                .eventCallback("onStart", ()=>this.setState({zIndex:99999}))
                .eventCallback("onReverseComplete", ()=>this.setState({zIndex:-1}))
        }



    }


    render() {

        return (
            <div className={'nrt-menu '} style={{
                zIndex: this.state.zIndex
            }}>
                <div className={'menu-overlay'}>

                    <nav>
                        <ul ref={ul => this.ul = ul}>
                            <li>Login</li>
                            <li>Novo cadastro</li>
                            <li>Fechar</li>
                        </ul>
                    </nav>
                </div>
            </div>
        )
    }
}


NRTMenu.propTypes = {
    open: PropTypes.bool,
}

NRTMenu.defaultProps = {
    open: false,
}

export default NRTMenu



// WEBPACK FOOTER //
// ./src/components/_common/Menu/index.js